import React from 'react';
import PropTypes from 'prop-types';
import calendarIcon from '../../images/calendar_icon_red.svg';
import replayerTvIcon from '../../images/replayer_tv_icon.svg';

const PublicPartnerSkyworkHero = ({hero, loading, onAction}) => {
  if (!hero && !loading) {
    return null;
  }

  if (loading && !hero) {
    return (
      <header className="replayer-club-page__hero replayer-club-page__hero--loading" aria-busy="true">
        <div className="replayer-club-page__hero-media-skeleton"/>
        <div className="replayer-club-page__hero-copy-skeleton">
          <span/>
          <span/>
          <span/>
        </div>
      </header>
    );
  }

  return (
    <header className="replayer-club-page__hero" aria-labelledby="replayer-club-page-title">
      <div className={`replayer-club-page__hero-media ${hero.heroImageUrl
        ? 'replayer-club-page__hero-media--image'
        : 'replayer-club-page__hero-media--fallback'}`}
      >
        {hero.heroImageUrl ? (
          <img src={hero.heroImageUrl} alt={hero.heroAlt}/>
        ) : (
          <div className="replayer-club-page__hero-fallback" aria-hidden="true">
            <img src={replayerTvIcon} alt=""/>
            <span>REPLAYERTV</span>
          </div>
        )}
        <div className="replayer-club-page__hero-media-overlay"/>
        {(hero.location || hero.channelCountLabel) && (
          <div className="replayer-club-page__hero-caption">
            {hero.location && <strong>{hero.location}</strong>}
            {hero.channelCountLabel && <span>{hero.channelCountLabel}</span>}
          </div>
        )}
      </div>

      <div className="replayer-club-page__hero-copy">
        <div className="replayer-club-page__hero-grid-mark" aria-hidden="true"/>
        <span className="replayer-club-page__hero-eyebrow">{hero.eyebrow}</span>
        <div className="replayer-club-page__hero-identity">
          {hero.logoUrl && (
            <span className="replayer-club-page__hero-logo">
              <img src={hero.logoUrl} alt={hero.logoAlt}/>
            </span>
          )}
          <h1 id="replayer-club-page-title">
            <span className="replayer-club-page__hero-title-primary">{hero.namePrimary || hero.name}</span>
            {hero.nameAccent && <span className="replayer-club-page__hero-title-accent">{hero.nameAccent}</span>}
          </h1>
        </div>
        {hero.location && (
          <p className="replayer-club-page__hero-location">{hero.location}</p>
        )}
        <p className="replayer-club-page__hero-description">{hero.description}</p>
        <div className="replayer-club-page__hero-actions">
          <button
            type="button"
            className="replayer-club-page__hero-action replayer-club-page__hero-action--primary"
            onClick={() => onAction(hero.primaryAction)}
          >
            <img src={replayerTvIcon} alt="" aria-hidden="true"/>
            <span>{hero.primaryAction.label}</span>
          </button>
          {hero.secondaryAction && (
            <button
              type="button"
              className="replayer-club-page__hero-action replayer-club-page__hero-action--secondary"
              onClick={() => onAction(hero.secondaryAction)}
            >
              <img src={calendarIcon} alt="" aria-hidden="true"/>
              <span>{hero.secondaryAction.label}</span>
            </button>
          )}
        </div>
        {hero.accessItems.length > 0 && (
          <div className="replayer-club-page__hero-access">
            {hero.accessItems.map(item => <span key={item}>{item}</span>)}
          </div>
        )}
      </div>
    </header>
  );
};

PublicPartnerSkyworkHero.propTypes = {
  hero: PropTypes.shape({
    accessItems: PropTypes.arrayOf(PropTypes.string).isRequired,
    channelCountLabel: PropTypes.string,
    description: PropTypes.string.isRequired,
    eyebrow: PropTypes.string.isRequired,
    heroAlt: PropTypes.string.isRequired,
    heroImageUrl: PropTypes.string,
    location: PropTypes.string,
    logoAlt: PropTypes.string.isRequired,
    logoUrl: PropTypes.string,
    name: PropTypes.string.isRequired,
    nameAccent: PropTypes.string,
    namePrimary: PropTypes.string,
    primaryAction: PropTypes.shape({
      id: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired
    }).isRequired,
    secondaryAction: PropTypes.shape({
      id: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired
    })
  }),
  loading: PropTypes.bool,
  onAction: PropTypes.func.isRequired
};

PublicPartnerSkyworkHero.defaultProps = {
  hero: null,
  loading: false
};

export default PublicPartnerSkyworkHero;
